import { faClipboardList } from '@fortawesome/pro-light-svg-icons'
import { Box, Button, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { BasicEmptyState } from '@scoir/empty-state'

import { useFocusedApplicationCycle, useIsPermittedToConfigure } from '../AppRoundProvider'
import { useAppCycleYearRange } from '../AppRoundSection/app-round-helper'
import { useRequirements } from '../RoundRequirementsProvider'
import { RequirementsGrid } from './RequirementsGrid'
import RequirementsModalTrigger from './RequirementsModal'

export const noRequirementsTitle = 'No requirements added yet!'
export const noRequirementsSubtitle = 'Get started by clicking "Create New Requirements" above.'

const useStyles = makeStyles((theme) => ({
  pageHeader: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: 500,
    marginBottom: theme.spacing(1),
  },
  pageSubheader: {
    fontSize: theme.typography.pxToRem(16),
  },
}))

const AppRequirements = () => {
  const { pageHeader, pageSubheader } = useStyles()
  const applicationCycle = useFocusedApplicationCycle()
  const appYearRange = useAppCycleYearRange(applicationCycle)
  const requirements = useRequirements()
  const noRequirements = requirements.length === 0
  const canConfigure = useIsPermittedToConfigure()
  return (
    <Box>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        mb={3}
      >
        <Box mr={1}>
          <Typography
            variant="h6"
            component="h2"
            className={pageHeader}
          >
            {appYearRange} Application Requirements
          </Typography>
          <Typography
            variant="body2"
            className={pageSubheader}
          >
            Establish recommendation and document requirements for applicants.
          </Typography>
        </Box>
        <RequirementsModalTrigger
          Component={Button}
          disabled={!canConfigure}
          color="primary"
          variant="contained"
        >
          Create New Requirements
        </RequirementsModalTrigger>
      </Box>
      {noRequirements ? (
        <BasicEmptyState
          title={noRequirementsTitle}
          subTitle={noRequirementsSubtitle}
          icon={faClipboardList}
        />
      ) : (
        <RequirementsGrid
          requirements={requirements}
          canConfigure={canConfigure}
        />
      )}
    </Box>
  )
}

export default AppRequirements
